'use client'

import { Button, LeftArrow, RightArrow } from '@desoutter/uikit'
import { CardsCarouselBlockViewerFragment } from './CardsCarouselBlockViewer.generated'
import { useState } from 'react'
import CardCarousel from '../../../Cards/CardCarousel/CardCarousel'

type CardsCarouselBlockViewerProps = {
	fragment: CardsCarouselBlockViewerFragment
}

export default function CardsCarouselBlockViewer({
	fragment,
}: CardsCarouselBlockViewerProps) {
	const [curr, setCurr] = useState(0)

	const prev = () => {
		setCurr((curr) => (curr === 0 ? fragment.cards.length - 1 : curr - 1))
	}

	const next = () => {
		setCurr((curr) => (curr === fragment.cards.length - 1 ? 0 : curr + 1))
	}

	return (
		<div className="flex flex-col w-full gap-8">
			<div className="flex flex-col w-full">
				<div className="flex justify-end w-full gap-2">
					<Button
						title="prev"
						icon={LeftArrow}
						color="adaptive"
						className={'border border-gray-100 dark:border-gray-800'}
						onClick={prev}
					/>
					<Button
						title="next"
						icon={RightArrow}
						color="adaptive"
						className={'border border-gray-100 dark:border-gray-800'}
						onClick={next}
					/>
				</div>
			</div>

			<div className="relative">
				<div
					className="relative flex transition-transform ease-out duration-500"
					style={{ transform: `translateX(-${curr * 300}px)` }}
				>
					{fragment.cards.map((card) => (
						<CardCarousel key={card.id} fragment={card} />
					))}
				</div>
			</div>
		</div>
	)
}
